import { genWorkspaceHeader } from '../../../utils/constants';
import { FILE_URL } from '../../../utils/apiEndpoints';
import clientService from '../../../apiClient';

/**
 * Converts a folder back to a file if it meets the criteria.
 * @param {Object} params - Parameters for the function.
 * @param {string} params.id - The ID of the folder to be converted (folderId).
 * @param {string} params.workspaceId - The workspace ID for API headers.
 * @param {Object} params.folderMappings - Map of folder IDs to folder data.
 * @returns {Object} - The result of the conversion process.
 */
export const convertFolderToFile = async ({ id, workspaceId, folderMappings }) => {
  if (!id) return { conversionData: null, convertedParentToFile: false };
  const folder = folderMappings[id];
  const folderDefaultFile = folder?.meta_info?.default_file;
  const shouldConvertParentBackToFile = folder?.children?.length <= 2 && folderDefaultFile != undefined;

  if (!shouldConvertParentBackToFile || !folderDefaultFile)
    return { conversionData: null, convertedParentToFile: shouldConvertParentBackToFile };

  const file = Object.values(folderMappings).find(
    (item) => item?.ref_id && String(item?.id) === String(folderDefaultFile)
  );
  const file_id = file['id'];
  const response = await clientService.post(`${FILE_URL}/${file_id}/convert_to_file`, null, {
    headers: genWorkspaceHeader(workspaceId),
  });
  return {
    conversionData: response?.data,
    convertedParentToFile: shouldConvertParentBackToFile,
    convertedFolderId: id,
  };
};

export default convertFolderToFile;
